module.exports = __webpack_public_path__ + "img/icon_success@3x.b1b5fca4.png";